<template>
    <div>
        <FlashcardShowHeader
            :flashcard-set="flashcardsSet"
            :user="user"
        />
        <FlashcardShowList :flashcard-set="flashcardsSet" />
    </div>
</template>

<script>
import FlashcardShowList from '@components/Flashcard/FlashcardShowList.vue';
import FlashcardShowHeader from '@components/Flashcard/FlashcardShowHeader.vue';

export default {
    name: 'FlashcardShow',
    components: {
        FlashcardShowList,
        FlashcardShowHeader,
    },
    data() {
        return {
            flashcardsSet: sdWindow.flashcards.set,
            user: sdWindow.flashcards.user || null,
        };
    },

    computed: {
        isAuth() {
            return !!sdWindow.flashcards.user;
        },
    },
    async created() {
        if (!this.isLoggedIn && sdWindow.flashcards.set.course && sdWindow.flashcards.set.course.university) {
            this.$store.dispatch('university/setCurrentUniversity', {
                id: sdWindow.flashcards.set.course.university.id,
                isTop: sdWindow.flashcards.set.course.university.top === 1,
                name: sdWindow.flashcards.set.course.university.name,
            });
        }
    },
};
</script>
